export default function Statistics() {
  return (
    <section className="py-16 bg-gradient-to-br from-[#1e3a5f] to-[#2d5a8f]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-shadow">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl">
                <i className="ri-time-line text-3xl text-[#FF6B35]"></i>
              </div>
              <div>
                <div className="text-4xl font-bold text-[#1e3a5f]">25+</div>
                <div className="text-sm text-gray-600 mt-1">Years of Combined Experience</div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-shadow">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl">
                <i className="ri-map-pin-line text-3xl text-[#FF6B35]"></i>
              </div>
              <div>
                <div className="text-4xl font-bold text-[#1e3a5f]">3</div>
                <div className="text-sm text-gray-600 mt-1">States Served</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
